import list from "./list";
import icon from '@mui/icons-material/Cancel';

const adminConfig = { list, icon };

export default adminConfig;